import React from 'react';
import { SlideContainer } from '../SlideContainer';
import { FadeInStagger, FadeIn } from '../FadeIn';
export const Slide02Opportunity = () => {
  return <SlideContainer data-id="element-27">
      <FadeInStagger className="max-w-4xl" data-id="element-28">
        <FadeIn data-id="element-29">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white mb-12 leading-tight" data-id="element-30">
            Conversation forces articulation.
            <br data-id="element-31" />
            <span className="text-white/40" data-id="element-32">
              Articulation forces understanding.
            </span>
          </h2>
        </FadeIn>

        <FadeIn data-id="element-33">
          <div className="prose prose-invert prose-lg md:prose-xl max-w-3xl text-white/70 leading-relaxed space-y-6" data-id="element-34">
            <p data-id="element-35">
              The most effective learning happens when students have to explain
              their thinking out loud, respond to challenges, and reason through
              problems in real time. This is why the case method works. It is
              why Socratic dialogue works. It is why the best mentors ask
              questions instead of giving answers.
            </p>
            <p data-id="element-36">
              The limitation has always been scale. A professor can only have so
              many one-on-one conversations. A TA team can only cover so many
              students. Class time is finite.
            </p>
            <p className="text-white font-medium" data-id="element-37">
              Master Ed removes that constraint. Every student gets a rigorous,
              adaptive, voice-first conversation built on the faculty's own
              content and frameworks. Anytime, anywhere.
            </p>
          </div>
        </FadeIn>
      </FadeInStagger>
    </SlideContainer>;
};